import * as React from 'preact/compat'
import GameCoverEditor from './GameCoverEditor'
import Modal from '../Modal'


export default ({ onClose, src, modalType, updateImage, steamId, gameName, oldLogo }: {
  onClose: () => void,
  src: string,
  modalType: 'square'|'large',
  updateImage: (src: string, files: FileList) => void,
  steamId?: string,
  gameName?: string,
  oldLogo?: string
}) => {
  const modal = React.useRef<Modal>()

  const closeModal = React.useCallback(() => {
    modal.current.close()
  }, [modal.current])

  return <Modal ref={modal} showClose={true} onClose={onClose} enableScroll={true}>
    <GameCoverEditor
      src={src}
      type={modalType}
      updateImage={updateImage}
      steamId={steamId}
      gameName={gameName}
      oldLogo={oldLogo}
      onClose={closeModal}
    />
  </Modal>
}
